import '@/assets/main.css'
import 'preline/preline'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'
import axios from 'axios'
import App from '@/App.vue'
import router from '@/router'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Import auth store after Pinia is set up
import { useAuthStore } from '@/stores/auth.store'

// Set up axios interceptor to always use fresh token from localStorage
axios.interceptors.request.use(
  (config) => {
    const userToken = JSON.parse(localStorage.getItem('userToken'))
    if (userToken) {
      config.headers.Authorization = `Bearer ${userToken}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Set up axios response interceptor to handle session timeout
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log('[Interceptor] Error caught:', {
      url: error.config?.url,
      status: error.response?.status,
      skipAuthInterceptor: error.config?.skipAuthInterceptor
    })

    // Skip interceptor if request has skipAuthInterceptor flag
    if (error.config?.skipAuthInterceptor) {
      console.log('[Interceptor] Skipping auth interceptor')
      return Promise.reject(error)
    }

    if (error.response?.status === 401) {
      // Session expired or unauthorized - force logout
      const authStore = useAuthStore()
      console.log('[Interceptor] 401 detected:', {
        hasToken: !!authStore.userToken,
        isLoggingOut: authStore.isLoggingOut
      })

      // Only force logout if user was previously authenticated and not already logging out
      if (authStore.userToken && !authStore.isLoggingOut) {
        console.log('[Interceptor] Triggering forced logout')
        authStore.logout()
      } else {
        console.log('[Interceptor] Skipping logout - already logging out or no token')
      }
    }
    return Promise.reject(error)
  }
)

Sentry.init({
  app,
  dsn: 'https://8700d6f2727d43599e10644509a20b19@o4508031795920896.ingest.de.sentry.io/4508319804162128',
  environment: import.meta.env.MODE
})

app.mount('#app')
